module.exports = __webpack_public_path__ + "d36f08331ad5c02410e91587f5207f9c.png";